import React from 'react';
import styled from '@emotion/styled';
import Upload from 'Components/Upload/index';
import Select from 'react-select';

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  background: #fff;
  padding: 16px;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const SearchInput = styled.div`
  position: relative;
  width: 280px;

  input {
    width: 100%;
    padding: 10px 16px 10px 40px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #2563eb;
    }
  }

  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid ${props => props.primary ? '#597EF7' : '#597EF7'};
  background: ${props => props.primary ? '#597EF7' : '#fff'};
  color: ${props => props.primary ? '#fff' : '#597EF7'};
  height: 36px;

  &:hover {
    background: ${props => props.primary ? '#1d4ed8' : '#f9fafb'};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const SearchSection = ({ onAdd, onUpload, onClickDownload, onSearch, search, providerId, vehicleTypeId, handleProviderChange, handleVehicleTypeChange, transportersList, vehicleTypes }) => {
  return (
    <SearchContainer>
      <SearchInput>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input 
          type="text" 
          placeholder="Search By Route Code / Vehicle No." 
          onChange={(e) => onSearch(e.target.value)}
          value={search}
        />
        </SearchInput>
        <Select
          options={transportersList || []}
          onChange={handleProviderChange}
          value={providerId && transportersList.find(item => item.id === providerId)}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          placeholder="Transporter Name"
          isClearable
          styles={{
            control: (base) => ({
              ...base,
              width: '250px'
            }),
          }}
        />
        <Select
          options={vehicleTypes || []}
          onChange={handleVehicleTypeChange}
          value={vehicleTypeId && vehicleTypes.find(item => item.value === vehicleTypeId)}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.value}
          placeholder="Vehicle Type"
          isClearable
          styles={{
            control: (base) => ({
              ...base,
              width: '200px',
            }),
          }}
        />
      <ButtonGroup>
        <Button onClick={() => onClickDownload(1)}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download Template
        </Button>
        <Upload onChange={onUpload}>
          <Button>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
            Upload Excel
          </Button>
          </Upload>
        <Button onClick={() => onClickDownload(2)}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download
        </Button>
        <Button primary onClick={onAdd}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add
        </Button>
      </ButtonGroup>
    </SearchContainer>
  );
};

export default SearchSection; 